export enum State {
    Open = 'Open',
    Opening = 'Opening',
    Closed = 'Closed',
    Closing = 'Closing',
}